import React from 'react';

const LidarAnnotationIcon: React.FC<React.SVGProps<SVGSVGElement>> = props => (
  <svg style={{ display: 'block', width: '100%' }} viewBox="0 0 88 87" {...props}>
    <g fillRule="nonzero" fill="none">
      <rect fill={props.color || '#9631E7'} x={0.7} y={0.4} width={86.6} height={86.6} rx={43.3} />
      <g fill="#FFF">
        <path opacity={0.5} d="M44 16.64L20.56 30.17v27.06L44 70.76l23.44-13.53V30.17z" />
        <path opacity={0.5} d="M20.56 30.17v27.06L44 70.76l23.44-13.53V30.17z" />
        <path opacity={0.5} d="M20.56 57.23L44 70.76l23.44-13.53V30.17z" />
        <path opacity={0.9} d="M44 70.76l23.44-13.53V30.17z" />
      </g>
    </g>
  </svg>
);

export default LidarAnnotationIcon;
